export interface UMFRProps {
  first_name: string;
  last_name: string;
  dni: string;
  email: string;
  phone: string;
  cuit: string;
}
export const getUMFilterRequest = (event: UMFRProps) => {
  return {
    ...(event?.first_name
      ? {
          Nombre: event?.first_name,
        }
      : {}),
    ...(event?.last_name
      ? {
          Apellido: event?.last_name,
        }
      : {}),
    ...(event?.dni
      ? {
          Documento: event?.dni,
        }
      : {}),
    ...(event?.email
      ? {
          Email: event?.email,
        }
      : {}),
    ...(event?.phone
      ? {
          Phone: event?.phone,
        }
      : {}),
    ...(event?.cuit
      ? {
          Cuit: event?.cuit,
        }
      : {}),
  };
};
